export default {
  title: 'Laskut',
  form: {
    auto_generate_invoices: {
      label: 'Luo laskut automaattisesti',
    },
  },
  buttons: {
    save: 'Tallenna',
  },
  toasts: {
    failed_to_save_changes: 'Muutosten tallennus epäonnistui',
    changes_got_saved: 'Muutokset tallennettu',
  },
};
